// React imports.
import React, { Component } from "react";

// App imports.
import Assessment1MainTable from "./Assessment1MainTable";
import Assessment1TopParagraph from "./Assessment1TopParagraph";
import Assessment1Questions from "./Assessment1Questions";
import Assessment1DownloadCSV from "./Assessment1DownloadCSV";
import TableLegendLeft from "./TableLegendLeft";

import { Assessment1StepsEnum } from "../state";
import { Assessment1FuelStatusEnum } from "../state";


const Assessment1 = ({ state }) => (
      <div>
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.EnterDataAverageExpenditures &&
              <div>
                  <p><strong><u>Step 1:</u>Enter your data</strong></p>

                  Assessment 1 is designed to help you take the average electric baseload expenditures for
                  households with each main heating fuel type from your data and compare it to reasonable estimates of
                  low-income electric baseload expenditures in your state.
                  <br/><br/>
                  If the data for the year you are trying to evaluate is available
                  in the Data Warehouse, it will be auto-populated below.
                  If this is the case, please verify that they are correct before clicking next.
                  <br/><br/>
                  If you are trying to evaluate a year for which data has not yet
                  been added to the Data Warehouse, you will need to manually
                  enter the <strong>Average Annual Electric Bill Expenditures</strong> from  
                  <strong>Section V, Part B, Line 5 of your Performance Data Form</strong>.

                  <br/>
                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]} state={state} />
                  <TableLegendLeft />
                  <br />

                  {state.Assessment1FuelTypesStatus.NaturalGas.computedAverageExpenditure === null
                    &&<span className="errorMessageText" >
                          Performance Measures data for Fiscal Year &nbsp;{state.SelectedYear}&nbsp;is not yet
                          available in the LIHEAP Data Warehouse. Please provide this information from Section
                          V, Part B, Line 4 of your Performance Data Form.
                      </span>
                  }
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.DisplaySeds &&
              <div>
                  <p><strong><u>Step 2:</u> Reviewing ACS data for your state</strong></p>
                  <p>
                      The American Community Survey (ACS) is a demographics survey program conducted by the U.S.
                      Census Bureau that regularly gathers information about American households and
                      individuals, including income, main heating fuel type, the average electric bill,
                      and average main heating bill.
                  </p>
                  <p>
                      Using the ACS data as a base, APPRISE has auto-populated the estimated annual
                      electric bill for LIHEAP eligible households in your state by fuel type in the
                      table below.
                  </p>
                  <p>
                      By comparing the average annual electric bill you reported in your Performance
                      Data Form to the average annual electric bill we would expect based on the ACS
                      data, we can get a sense of how reliable your data are for households of each
                      fuel type.
                  </p>

                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.PercentOfSeds &&
              <div>
                  <p>
                      <strong><u>Step 3:</u>Results Overview</strong>
                  </p>
                  <p>
                      Your low-income average electric baseload expenditure data should typically fall  
                      somewhere close to the estimated average annual baseload expenditures for
                      your state using the ACS data.
                  </p>
                  <p>
                      This assessment flags when your computed average electric baseload expenditures
                      are less than 50% or greater than 150% of the estimated average electric baseload
                      expenditures for your state based on the ACS. 
                  </p>
                  <p>
                      If your average electric baseload expenditure data does not fall within these
                      thresholds, vendors may not be including the correct expenditures in their reports
                      or they may not be reporting for the correct amount of time. 	
                  </p>
                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <br />
              </div> 
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.NaturalGasFollowup &&
              <div>
                  <p>
                      <strong><u>Step 3a:</u>Results - Natural Gas Households</strong>
                  </p>
                  <Assessment1TopParagraph state={state}  fuelType={state.Assessment1FuelTypesStatus.NaturalGas} />
                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <Assessment1Questions state={state}  fuelType={state.Assessment1FuelTypesStatus.NaturalGas} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.FuelOilFollowup &&
              <div>
                  <p>
                      <strong><u>Step 3b:</u>Results - Fuel Oil Households</strong>
                  </p>

                  <Assessment1TopParagraph state={state}  fuelType={state.Assessment1FuelTypesStatus.FuelOil} />
                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <Assessment1Questions state={state}  fuelType={state.Assessment1FuelTypesStatus.FuelOil} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.PropaneFollowup &&
              <div>
                  <p>
                      <strong><u>Step 3c:</u>Results - Propane Households</strong>
                  </p>
                  
                  <Assessment1TopParagraph state={state}  fuelType={state.Assessment1FuelTypesStatus.Propane} />
                  <Assessment1MainTable  fieldChangeHandler={state.assessment1FieldChangeHandler} holder={state.Assessment1FuelTypesStatus} step={state.Assessment1Steps[state.CurrentAssessementStepIndex]}state={state} />
                  <TableLegendLeft />
                  <Assessment1Questions state={state}  fuelType={state.Assessment1FuelTypesStatus.Propane} />
                  <br />
              </div>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.ActionPlanSummary &&
              <div>
                  <p>
                      <strong><u>Step 4:</u> Aggregated Action Plan </strong>
                  </p>
                  <p>
                      Congratulations! You have reached the end of Assessment #1 for Electric
                      Baseload Expenditures. Your aggregated action plan for every issue
                      identified in Assessment #1 is included in the table below. You
                      can now download or print the Assessment #1 action plan below.
                      Also, you can revisit this page at any time by selecting it
                      from the list of completed assessments on the Assessment Tool
                      Selection Page.
                  </p>
                  <table id="tblDataReliabilityActionPlan">
                      <thead>
                        <tr>
                            <th>Fuel</th>
                            <th>Issue</th>
                            <th>Action Plan</th>
                        </tr>
                      </thead>
                      <tbody>
                      {state.assessment1GetFuelTypesArray().map(fuel => {
                          return (
                              <React.Fragment key={fuel.description}>

                                  {(!state.showActionPlan(fuel))
                                  &&
                                  <tr>
                                      <td>{fuel.description}</td>
                                      <td colSpan={2}>N/A</td>
                                  </tr>}

                                  {(fuel.IncludingEnergyUseChargesFlag  == "N" || fuel.IncludingEnergyUseChargesFlag  == "U")
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Expenditure amounts reported vendors should include energy usage charges</td>
                                    <td>
                                      {fuel.IncludingEnergyUseChargesDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.IncludingEnergyDeliveryChargesFlag  == "N" || fuel.IncludingEnergyDeliveryChargesFlag  == "U")
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Expenditure amounts reported vendors should include include delivery, fixed charges,
                                        and taxes.</td>
                                    <td>
                                      {fuel.IncludingEnergyDeliveryChargesDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.IncludingEnergyOptionalChargesFlag  == "Y" || fuel.IncludingEnergyOptionalChargesFlag  == "U")
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Expenditure amounts reported by vendors should NOT include optional charges.</td>
                                    <td>
                                      {fuel.IncludingEnergyOptionalChargesDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.IncludeSupplierChargesFlag == "N" || fuel.IncludeSupplierChargesFlag  == "U")
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Expenditure amounts reported by vendors should include supplier charges.</td>
                                    <td>
                                      {fuel.IncludeSupplierChargesDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.Including12MonthOnlyFlag  == "N" || fuel.Including12MonthOnlyFlag  == "U")
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors should be reporting for a 12 month period only.</td>
                                    <td>
                                      {fuel.Including12MonthOnlyDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.IncludingComplete12MonthFlag  == "N" || fuel.IncludingComplete12MonthFlag  == "U")
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors should be reporting for a full 12 month period.</td>
                                    <td>
                                      {fuel.IncludingComplete12MonthDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.IndicatingLessThan12MonthFlag  == "N" || fuel.IndicatingLessThan12MonthFlag  == "U")
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>If a client`s expenditure data represents less than 12-months for any reason, this needs
                                        to be indicated and accounted when calculating your average expenditures.</td>
                                    <td>
                                      {fuel.IndicatingLessThan12MonthDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.ReportingAfterDiscountsFlag  == "N" || fuel.ReportingAfterDiscountsFlag  == "U")
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors should be sending billing data after low-income discounts have been applied.</td>
                                    <td>
                                      {fuel.ReportingAfterDiscountsDesc}
                                    </td>
                                  </tr>}
                                 {(fuel.CheckOutliersFlag == "N" || fuel.CheckOutliersFlag  == "U")
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors check outliers in the data they report to you to ensure that they did not make any errors.</td>
                                    <td>
                                      {fuel.CheckOutliersDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.IncludeOnlyAmountBilledFlag  == "N" || fuel.IncludeOnlyAmountBilledFlag  == "U")
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors should only include the new amounts that households are billed each month, and not the total amount owed.</td>
                                    <td>
                                      {fuel.IncludeOnlyAmountBilledDesc}
                                    </td>
                                  </tr>}

                                  {(fuel.SignificantSupplierChargesFlag  == "N" || fuel.SignificantSupplierChargesFlag  == "U")
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>You need to know whether a significant portion of your households  
                                        are being assessed third-party supplier charges.</td>
                                    <td>
                                      {fuel.SignificantSupplierChargesDesc}
                                    </td>
                                  </tr>}

                                  {(fuel.OtherReasonDesc != '' && fuel.OtherReasonDesc != null)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                        Potential data reliability issue cannot be
                                        explained by the most common reasons</td>
                                    <td>
                                      {fuel.OtherReasonDesc}
                                    </td>
                                  </tr>}
 

                                  {(fuel.computedAverageExpenditure === 0
                                      && fuel.totalAssistedhHNum>0
                                      && (fuel.ZeroAvgExpenditureDataReasonDesc != '' && fuel.ZeroAvgExpenditureDataReasonDesc != null))
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>
                                        Performance Measures Form indicates that you assisted households that used
                                        {fuel.description} for heating
                                        but did NOT collect and/or report data for any of those households</td>
                                    <td>
                                      {fuel.ZeroAvgExpenditureDataReasonDesc}
                                    </td>
                                  </tr>}
                              </React.Fragment>
                          )
                      })}
                      </tbody>
                  </table>
              </div>
          }
          <br />
          <button className="dataButton"
              onClick={() => state.assessment1ShowPreviousStep()}>
              Previous
          </button>
          {state.CurrentAssessementStepIndex < Assessment1StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment1ShowNextStep()}
                  disabled={state.Assessment1ShowNextStepDisabled === true}>
                  Next
              </button>
          }
          {state.CurrentAssessementStepIndex < Assessment1StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment1ShowActionPlan()}
                  disabled={state.Assessment1ShowNextStepDisabled === true}>
                  View Action Plan
              </button>
          }
          <br/>
          <button className="dataButton"
              onClick={() => state.backToStart()}>
              {state.CurrentAssessementStepIndex < Assessment1StepsEnum.ActionPlanSummary
              &&<React.Fragment>Back to start</React.Fragment>}
              {state.CurrentAssessementStepIndex === Assessment1StepsEnum.ActionPlanSummary
              &&<React.Fragment>Finish &amp; Save</React.Fragment>}
          </button>
          {state.CurrentAssessementStepIndex === Assessment1StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => window.print()}>
                  Print
              </button>
          }
          {state.CurrentAssessementStepIndex == Assessment1StepsEnum.ActionPlanSummary
          &&
            <Assessment1DownloadCSV fuelTypes={[state.Assessment1FuelTypesStatus.NaturalGas, state.Assessment1FuelTypesStatus.FuelOil, state.Assessment1FuelTypesStatus.Propane]}/>
          }
          <div style={{clear:"both"}}>&nbsp;</div>
      </div>
    );

export default Assessment1;
